import { useEffect } from "react";

import { useParams } from "react-router-dom";

import useNavigation from "./navigation";
import useAccount from "./useAccount";
import { useChinaUser } from "./useChinaUser";

export const useGuardChinaRestrictedPages = () => {
  const { teamID } = useParams();
  const navigation = useNavigation();
  const { isChinaUser, isLoading: isChinaUserLoading } = useChinaUser();
  const { data: accountData } = useAccount();

  const shouldRedirect = Boolean(isChinaUser && !accountData?.hasChargebeeSubscription);

  useEffect(() => {
    if (shouldRedirect && teamID) {
      navigation.goToTeamSubscription(teamID);
    }
  }, [shouldRedirect, navigation, teamID]);

  return shouldRedirect || isChinaUserLoading;
};
